import { render, staticRenderFns } from "./PosPT_Items.vue?vue&type=template&id=1b9beb8e"
import script from "./PosPT_Items.vue?vue&type=script&lang=js"
export * from "./PosPT_Items.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports